import { useState } from 'react';
import { Loader2, Mail } from 'lucide-react';
import { founderApi } from '@/lib/founderApi';
import { errMsg } from '@/lib/digitalApi';
import { usePageMeta } from '@/lib/usePageMeta';
import { FounderFrame } from '@/components/founder/FounderFrame';

export default function FounderLogin() {
  usePageMeta({ title: 'Founder Workspace Sign In', path: '/founder/login', robots: 'noindex' });
  const [email, setEmail] = useState('');
  const [state, setState] = useState({});

  const submit = async (e) => {
    e.preventDefault();
    setState({ loading: true });
    try {
      const r = await founderApi.requestLink(email);
      setState({ sent: r.message });
    } catch (err) {
      setState({ error: errMsg(err) });
    }
  };

  return (
    <FounderFrame eyebrow="ORIGENNE™ · Founder Workspace" testid="founder-login-page">
      <h1 className="font-serif-display text-5xl md:text-6xl tracking-tighter text-matte leading-[1.02]">
        Sign in to your <em className="italic text-taupe">Workspace.</em>
      </h1>
      <p className="mt-6 text-matte/70 leading-relaxed max-w-xl">
        Enter the email you used at purchase. We&rsquo;ll send a secure, single-use sign-in link. No password needed.
      </p>
      {state.sent ? (
        <div className="mt-10 rounded-2xl border border-gold/30 bg-white p-6 flex gap-4" data-testid="founder-login-sent">
          <Mail size={18} className="text-gold shrink-0 mt-1" />
          <p className="text-matte/80 text-sm leading-relaxed">{state.sent}</p>
        </div>
      ) : (
        <form onSubmit={submit} className="mt-10 max-w-md space-y-4" data-testid="founder-login-form">
          <input
            type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
            placeholder="you@business.com" autoComplete="email" aria-label="Email address"
            className="w-full rounded-full border border-matte/15 bg-white px-6 py-4 text-sm focus:outline-none focus:border-gold"
            data-testid="founder-login-email-input"
          />
          {state.error && <p className="text-sm text-red-700" data-testid="founder-login-error">{state.error}</p>}
          <button type="submit" disabled={state.loading} className="btn-primary" data-testid="founder-login-submit-button">
            {state.loading && <Loader2 size={14} className="animate-spin" />} Email Me a Sign-In Link
          </button>
        </form>
      )}
    </FounderFrame>
  );
}
